    <template>
        <div class="ele-body">
            <el-card shadow="never">
                <!-- 搜索表单 -->
                <el-form v-if="search_show" :model="table.where" label-width="auto" :inline="true"
                    @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
                    <el-row :gutter="15">
                        <el-form-item label="店铺:">
                            <el-select v-model="table.where.shop_id" filterable placeholder="请选择">
                                <el-option v-for="item in store_shop_management_list" :key="item.id" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="标题:">
                            <el-input v-model="table.where.title" placeholder="请输入标题" clearable />
                        </el-form-item>

                        <el-form-item label="满足金额:">
                            <el-input-number v-model="table.where.meet_price" controls-position="right" :min="0"
                                :controls="false" :precision="2" class="ele-fluid ele-text-left" placeholder="请输入满足金额"
                                clearable />
                        </el-form-item>


                        <el-form-item label="类型:">
                            <el-select v-model="table.where.type" filterable placeholder="请选择">
                                <el-option label="满减劵" value="1"></el-option>
                                <el-option label="立减劵" value="2"></el-option>
                                <el-option label="折扣券" value="3"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="金额:">
                            <el-input-number v-model="table.where.price" controls-position="right" :min="0"
                                :controls="false" :precision="2" class="ele-fluid ele-text-left" placeholder="请输入金额"
                                clearable />
                        </el-form-item>


                        <el-form-item label="开始时间:">
                            <el-date-picker v-model="table.where.start_time" type="datetimerange"
                                start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                            </el-date-picker>
                        </el-form-item>

                        <el-form-item label="结束时间:">
                            <el-date-picker v-model="table.where.end_time" type="datetimerange" start-placeholder="开始日期"
                                end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                            </el-date-picker>
                        </el-form-item>

                        <el-form-item label="创建时间:">
                            <el-date-picker v-model="table.where.create_time" type="datetimerange"
                                start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                            </el-date-picker>
                        </el-form-item>

                        <el-form-item label="排序:">
                            <el-input-number v-model="table.where.sort" placeholder="请输入排序" :controls="false"
                                controls-position="right" class="ele-fluid ele-text-left" clearable />
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                                class="ele-btn-icon">查询
                            </el-button>
                            <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                            <el-button type="success" @click="exportExcel();" icon="el-icon-download"
                                class="ele-btn-icon" v-if="permission.includes('sys:storecoupon:export')">导出数据
                            </el-button>
                        </el-form-item>
                    </el-row>
                </el-form>
                <!-- 操作按钮 -->

                <div class="ele-table-tool ele-table-tool-default">
                    <el-button @click="(table.where={})&&$refs.table.reload()" type="info" icon="el-icon-refresh"
                        class="ele-btn-icon" size="small">刷新
                    </el-button>
                    <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon"
                        size="small" v-if="permission.includes('sys:storecoupon:add')">添加
                    </el-button>
                    <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small"
                        v-if="permission.includes('sys:storecoupon:dall')">批量删除
                    </el-button>
                    <el-button :type="search_show?'warning':'info'" size="small" icon="el-icon-search"
                        @click="search_show=!search_show">搜索</el-button>
                </div>

                <!-- 数据表格 -->
                <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)"
                    highlight-current-row>
                    <template slot-scope="{index}">
                        <el-table-column type="selection" width="45" align="center" fixed="left" />
                        <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left"
                            show-overflow-tooltip />
                            
                        <el-table-column prop="shop_id_info.name" label="店铺名称" sortable="custom" show-overflow-tooltip
                            min-width="120">
                            <template slot-scope="{row}">
                                <div v-if="row.shop_id_info.length>0">
                                    <div v-for="(item,index) in row.shop_id_info" :key="index">
                                        {{ item.name }}
                                    </div>
                                </div>
                                <div v-else>
                                    <div >
                                       全场通用
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="type" label="类型" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-tag v-if="row.type == 1" :key="index">满减劵</el-tag>
                                <el-tag v-if="row.type == 2" :key="index">立减劵</el-tag>
                                <el-tag v-if="row.type == 3" :key="index">折扣券</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="title" label="标题" sortable="custom" show-overflow-tooltip
                            min-width="120" />
                        <el-table-column prop="meet_price" label="满足金额" sortable="custom" show-overflow-tooltip
                            min-width="120">
                            <template slot-scope="{row}">
                                <el-tag v-if="row.type == 1" :key="index">
                                    满{{row.meet_price}}元减{{row.price}}元
                                </el-tag>
                                <el-tag v-if="row.type == 2" :key="index">
                                    立减{{row.price}}元
                                </el-tag>
                                <el-tag v-if="row.type == 3" :key="index">
                                    {{row.discount}}折
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="start_time" label="开始时间" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="end_time" label="结束时间" sortable="custom" show-overflow-tooltip
                            min-width="120" />
                        <el-table-column prop="sort" label="排序" sortable="custom" show-overflow-tooltip
                            min-width="120" />
                        
                        <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
                        </el-table-column>
                        
                        <el-table-column label="操作" width="130px" align="center" :resizable="false" fixed="right">
                            <template slot-scope="{row}">
                                <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false"
                                    v-if="permission.includes('sys:storecoupon:edit')">修改</el-link>
                                <el-popconfirm title="确定要删除此优惠券吗？" @confirm="remove(row)" class="ele-action">
                                    <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false"
                                        v-if="permission.includes('sys:storecoupon:delete')">删除</el-link>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </template>
                </ele-data-table>
            </el-card>
            <!-- 编辑弹窗 -->
            <el-dialog :title="editForm.id?'修改优惠券':'添加优惠券'" :visible.sync="showEdit" width="800px"
                :destroy-on-close="true" :lock-scroll="false" @close="closeDialog" :close-on-click-modal="false">
                <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">
                    

                    <el-form-item label="店铺:" prop="shop_id">
                        <el-select v-model="editForm.shop_id" filterable placeholder="请选择" @change="selectShopId">
                            <el-option v-for="item in store_shop_management_list" :key="item.id" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="商品分类:" prop="cat_id">
                        <el-cascader-panel v-model="temp_goods_cat_id" :options="store_shop_goods_cat_list" :props="{value:'id',label:'name',multiple:true}">
                        </el-cascader-panel>
                    </el-form-item>
                    <el-form-item label="模式:" prop="mode">
                        <el-select v-model="editForm.mode" filterable placeholder="请选择模式">
                            <el-option label="普通券" value="1"></el-option>
                            <el-option label="消费券" value="2"></el-option>
                            <el-option label="新人券" value="3"></el-option>
                            <el-option label="会员券" value="4"></el-option>
                            <el-option label="积分兑换券" value="5"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="消费金额(元):" v-if="editForm.mode == 2" prop="use_price">
                        <el-input-number v-model="editForm.use_price" controls-position="right" :min="0"
                            :controls="false" :precision="2" class="ele-fluid ele-text-left" placeholder="请输入消费金额"
                            clearable />
                    </el-form-item>
                    <el-form-item label="优惠券标题:" prop="title">
                        <el-input v-model="editForm.title" placeholder="请输入优惠券标题" clearable />
                    </el-form-item>
                    <el-form-item label="类型:" prop="type">
                        <el-select v-model="editForm.type" filterable placeholder="请选择类型">
                            <el-option label="满减劵" value="1"></el-option>
                            <el-option label="立减劵" value="2"></el-option>
                            <el-option label="折扣券" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="editForm.type == 1" label="满足金额(元):" prop="meet_price">
                        <el-input-number v-model="editForm.meet_price" controls-position="right" :min="0"
                            :controls="false" :precision="2" class="ele-fluid ele-text-left" placeholder="请输入满足金额"
                            clearable />
                    </el-form-item>
                    <el-form-item v-if="editForm.type != 3" label="金额(元):" prop="price">
                        <el-input-number v-model="editForm.price" controls-position="right" :min="0" :controls="false"
                            :precision="2" class="ele-fluid ele-text-left" placeholder="请输入金额" clearable />
                    </el-form-item>
                    <el-form-item v-if="editForm.type == 3" label="折扣(%):" prop="discount">
                        <el-input-number v-model="editForm.discount" controls-position="right" :min="0" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入折扣(%)" clearable />
                    </el-form-item>
                    <el-form-item label="活动开始时间:" prop="activity_start_time">
                        <el-date-picker v-model="editForm.activity_start_time" type="datetime" placeholder="选择活动开始时间" size="small"
                            value-format="yyyy-MM-dd hh:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="活动结束时间:" prop="activity_end_time">
                        <el-date-picker v-model="editForm.activity_end_time" type="datetime" placeholder="选择活动结束时间" size="small"
                            value-format="yyyy-MM-dd hh:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="使用开始时间:" prop="start_time">
                        <el-date-picker v-model="editForm.start_time" type="datetime" placeholder="选择使用开始时间" size="small"
                            value-format="yyyy-MM-dd hh:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="使用结束时间:" prop="end_time">
                        <el-date-picker v-model="editForm.end_time" type="datetime" placeholder="选择使用结束时间" size="small"
                            value-format="yyyy-MM-dd hh:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                    
                    <el-form-item label="使用规则:" prop="explain_id">
                        <el-select v-model="editForm.explain_id" filterable placeholder="请选择">
                            <el-option v-for="item in store_coupon_explain_list" :key="item.id" :label="item.title"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="排序:" prop="sort">
                        <el-input-number v-model="editForm.sort" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入排序" clearable />
                    </el-form-item>
                </el-form>
                <div slot="footer">
                    <el-button @click="closeDialog">取消</el-button>
                    <el-button type="primary" @click="save">保存</el-button>
                </div>
            </el-dialog>
        </div>
    </template>

    <script>
        import {
            mapGetters
        } from "vuex";
        export default {
            name: "SysStoreCoupon",
            components: {},
            data() {
                return {
                    table: {
                        url: '/store/StoreCoupon/index',
                        where: {}
                    }, // 表格配置
                    choose: [], // 表格选中数据
                    showEdit: false, // 是否显示表单弹窗
                    editForm: {
                        type:'1',
                        mode:'1'
                    }, // 表单数据
                    editFormTemp: {},
                    admin_list: [],
                    user_list: [],
                    search_show: false,
                    store_coupon_explain_list: [],
                    store_shop_management_list: [],
                    store_shop_goods_cat_list:[],
                    temp_goods_cat_id:[],
                    cat_id:[],
                    editRules: { // 表单验证规则

                        shop_id: [{
                            required: true,
                            message: '请选择店铺id',
                            trigger: 'blur'
                        }],


                        title: [{
                            required: true,
                            message: '请输入标题',
                            trigger: 'blur'
                        }],
                        meet_price: [{
                            required: true,
                            message: '请输入满足金额',
                            trigger: 'blur'
                        }],
                        use_price:[{
                            required: true,
                            message: '请输入消费金额',
                            trigger: 'blur'
                        }],

                        type: [{
                            required: true,
                            message: '请选择类型',
                            trigger: 'blur'
                        }],
                        mode:[{
                            required: true,
                            message: '请选择模式',
                            trigger: 'blur'
                        }],
                        discount:[
                            {
                                required: true,
                                message: '请输入折扣',
                                trigger: 'blur'
                            }
                        ],

                        price: [{
                            required: true,
                            message: '请输入金额',
                            trigger: 'blur'
                        }],


                        start_time: [{
                            required: true,
                            message: '请选择开始时间',
                            trigger: 'blur'
                        }],


                        activity_end_time: [{
                            required: true,
                            message: '请选择活动结束时间',
                            trigger: 'blur'
                        }],
                        activity_start_time: [{
                            required: true,
                            message: '请选择活动开始时间',
                            trigger: 'blur'
                        }],
                        
                        end_time: [{
                            required: true,
                            message: '请选择结束时间',
                            trigger: 'blur'
                        }],


                        explain_id: [{
                            required: true,
                            message: '请选择使用规则id',
                            trigger: 'blur'
                        }],

                        create_time: [{
                            required: true,
                            message: '请选择创建时间',
                            trigger: 'blur'
                        }],



                   

                        name: [{
                            required: true,
                            message: '请输入店铺名称',
                            trigger: 'blur'
                        }],


                    },
                }
            },
            computed: {
                ...mapGetters(["permission"]),
            },
            mounted() {

                this.StoreCouponExplainAllList();
                this.StoreShopManagementAllList();
            },
            methods: {
                /**
                 * 关闭
                 */
                closeDialog() {
                    this.showEdit = false;
                    this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
                },
                /**
                 * 显示编辑
                 */
                edit(row) {
                    this.$http.get('/store/StoreCoupon/info?id=' + row.id).then(res => {
                        if (res.data.code === 0) {
                            this.showEdit = true;
                            res.data.data.temp_goods_cat_id = res.data.data.temp_goods_cat_id? JSON.parse(res.data.data.temp_goods_cat_id):[];
                            this.temp_goods_cat_id = res.data.data.temp_goods_cat_id;
                            this.selectShopId(res.data.data.shop_id);
                            setTimeout(() => {
                                this.editForm = res.data.data;
                            }, 100);
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                /**
                 * 保存编辑
                 */
                save() {
                    this.$refs['editForm'].validate((valid) => {
                        if (valid) {
                            let goods_cat_ids = [];
                            for(var i = 0;i<this.temp_goods_cat_id.length;i++){
                                goods_cat_ids.push(this.temp_goods_cat_id[i][this.temp_goods_cat_id[i].length-1])
                            }
                            this.editForm.goods_cat_ids = goods_cat_ids;
                            this.editForm.temp_goods_cat_id = JSON.stringify(this.temp_goods_cat_id);
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/store/StoreCoupon/edit', this.editForm).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.showEdit = false;
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        } else {
                            return false;
                        }
                    });
                },
                /**
                 * 刪除(批量刪除)
                 */
                remove(row) {
                    console.log(row)
                    if (!row) { // 批量删除
                        if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                        let ids = this.choose.map(d => d.id);
                        this.$confirm('确定要删除选中的优惠券吗?', '提示', {
                            type: 'warning'
                        }).then(() => {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/store/StoreCoupon/delete', {
                                id: ids
                            }).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        }).catch(() => 0);
                    } else { // 单个删除
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/store/StoreCoupon/delete', {
                            id: row.id
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }
                },

                /* 导出数据Excel */
                exportExcel() {
                    let ids = this.choose.map(d => d.id)
                    if (ids.length == 0) {
                        this.$message.error('请选择要导出的数据');
                        return false;
                    }
                    this.$http
                        .post("/store/StoreCoupon/exportExcel", {
                            id: ids
                        })
                        .then((res) => {
                            let data = res.data;
                            if (data.code == 0) {
                                // 下载文件
                                window.location.href = data.data;
                                this.$message({
                                    type: "success",
                                    message: "导出成功",
                                });
                            } else {
                                this.$message.error("导出失败");
                            }
                        })
                },
                //获取分类
                selectShopId(shop_id){
                    let data = {}
                    if(shop_id != 0){
                        data = {
                            shop_id:shop_id,
                        }
                    }
                    this.$http.post('/store/StoreGoodsCat/allList', data).then(res => {
                        if (res.data.code === 0) {
                            this.store_shop_goods_cat_list = res.data.data;
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                //查询其他信息
                StoreCouponExplainAllList() {
                    this.$http.post('/store/StoreCouponExplain/allList', {}).then(res => {
                        if (res.data.code === 0) {
                            this.store_coupon_explain_list = res.data.data;
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                //查询其他信息
                StoreShopManagementAllList() {
                    this.$http.post('/store/StoreShopManagement/allList', {}).then(res => {
                        if (res.data.code === 0) {
                            
                            this.store_shop_management_list = res.data.data;
                            let temp_data = {
                                id:0,
                                name:'全场通用'
                            }
                            this.store_shop_management_list.unshift(temp_data)
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },

            }
        }
    </script>

    <style scoped>
        .ele-block>>>.el-upload,
        .ele-block>>>.el-upload-dragger {
            width: 100%;
        }
    </style>